var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.168,
    height: 13.919,
    viewBox: "0 0 15.168 13.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_63",
    "data-name": "Soustraction 63",
    d: "M16997.58-6898h-11.162a1.981,1.981,0,0,1-1.723-.989,1.983,1.983,0,0,1-.018-1.994l5.58-9.919a1.98,1.98,0,0,1,1.744-1.017,1.977,1.977,0,0,1,1.742,1.017l5.58,9.919a1.978,1.978,0,0,1-.016,1.991A1.985,1.985,0,0,1,16997.58-6898Zm-5.586-4.147a1.12,1.12,0,0,0-.822.341,1.119,1.119,0,0,0-.342.828,1.118,1.118,0,0,0,.342.828,1.12,1.12,0,0,0,.822.341,1.136,1.136,0,0,0,.832-.345,1.126,1.126,0,0,0,.346-.824,1.118,1.118,0,0,0-.346-.828A1.149,1.149,0,0,0,16991.994-6902.147Zm-.941-8.162h0v7.347h1.885v-7.347h-1.885Z",
    transform: "translate(-16984.418 6911.919)",
    fill: "#bb1412"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.baa1aec2c5809c6377546ea20dafd535.svg";
export { ForwardRef as ReactComponent };